<template>
  <v-app-bar dark height="60" :app="fixHeader ? true : false" :class="['customizeHeader', {'fixed': fixHeader}]">
    <div class="left">
      <h3 v-if="home !== false">
        <v-img width="120" src="/img/logo.png" class="pointer no-background" @click="$router.push('/')"></v-img>
      </h3>
      <v-btn icon v-else-if="goBack" @click="$func.goBack()">
        <v-icon>fa-chevron-left</v-icon>
      </v-btn>
      <h3 class="ml-4" v-if="title">{{ title }}</h3>
      <slot name="left"></slot>
    </div>
    <div class="right">
      <slot name="right" v-if="right !== false"></slot>
      <template v-else>
        <v-btn icon class="mx-1 base" to="/shoppingcart">
          <v-badge offset-x="10" offset-y="10" color="pink" :content="totalNum.toString()">
            <v-icon>fa-shopping-cart</v-icon>
          </v-badge>
        </v-btn>
        <template v-if="!isLogin">
          <router-link to="/login" class="d-flex">
            <v-icon left small color="white">fa-user</v-icon>
            登入
          </router-link>
        </template>
        <template v-else>
          <div class="tablet-only desktop-only hidden">
            <a class="base d-flex align-center" @click="$root.$emit('peachList')">
              <div class="peach"></div>
              <span class="pink--text">{{ user.peach }}</span>
            </a>
          </div>
          <router-link to="/profile" class="nickname">
            {{ user.nickname }}
          </router-link>
        </template>
      <!--   <div class="tablet-only mobile-only hidden">
          <v-btn icon @click="$refs.fullScreenMenu.dialog = true">
            <v-icon>fa-bars</v-icon>
          </v-btn>
        </div>
        <FullScreenHeader ref="fullScreenMenu"></FullScreenHeader> -->
      </template>
    </div>
  </v-app-bar>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import FullScreenHeader from '@/components/FullScreenHeader'
export default {
  components: { FullScreenHeader },
  props: {
    home: {
      default: false
    },
    goBack: {
      default: true
    },
    title: {
      default: ''
    },
    right: {
      default: false
    }
  },
  data() {
    return {
      pageOffset: window.pageYOffset
    }
  },
  computed: {
    ...mapState('user', ['user']),
    ...mapGetters('user', ['isLogin']),
    ...mapGetters('shoppingCart', ['totalNum']),
    fixHeader() {
      return !this.$store.state.user.haveNotification || this.pageOffset > 30
    }
  },
  mounted() {
    window.addEventListener('scroll', () => {
      this.pageOffset = window.pageYOffset
    })
  }
}
</script>

<style lang="scss" scoped>
.fixed {
  position: fixed !important;
  top: 0;
  left: 0;
  widtH: 100%;
  z-index: 100;
}
.customizeHeader {
  background: $grey-3 !important;
  max-height: 60px;
  padding: 0 50px;
  @include mobile {
    padding: 0;
  }
  @include tablet {
    padding: 0;
  }
  .left, .right {
    display: flex;
    align-items: center;
    position: absolute;
  }
  .left {
    left: 0;
  }
  .right {
    right: 0;
  }
  .v-toolbar__content {
    justify-content: center;
  }
  a {
    margin: 0 12px;
    position: relative;
    text-decoration: none;
    color: white !important;
    &:not(.base):hover {
      color: $main !important;
      i {
        color: $main !important;
      }
      &::after {
        content: '';
        width: 100%;
        height: 2px;
        background-color: $main;
        position: absolute;
        left: 0;
        bottom: -5px;
      }
    }
  }
  .v-icon {
    transition: none !important;
    color: white !important;
  }
}
</style>